/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import httpApi from "./httpApi";

/**
 * This method is used  to get Season list
 * */

const getSeasonList = async (seasonId, page = 0, size) => {
  const params = {
    seasonId,
    page,
    size,
  };
  const response = await httpApi.get("/v1/seasons", { params });
  if (response && response.data) {
    return response.data;
  }

  return null;
};

/**
 * This method is used to Add Season
 * */
const addSeason = async (requestData) => {
  const response = await httpApi.post("/v1/seasons", requestData);
  if (response && response.data) {
    return response.data;
  }

  return null;
};

/**
 * This method is used to Edit Season Details
 * */
const editSeasonDetails = async (id, requestData) => {
  const response = await httpApi.put(`/v1/seasons/id/${id}`, requestData);
  if (response && response.data) {
    return response.data;
  }

  return null;
};

/**
 * This method is used to delete a Season
 * @param id
 */
const deleteSeason = async (id) => {
  const response = await httpApi.delete(`/v1/seasons/id/${id}`);
  if (response && response.data) {
    return response.data;
  }
  return null;
};

export {
  getSeasonList,
  addSeason,
  editSeasonDetails,
  deleteSeason,
};
